export const sharedPeriodSelectorDe = {
  "Last 14 days": "letzte 14 Tage",
  "Last 30 days": "letzte 30 Tage",
  "Last 90 days": "letzte 90 Tage",
  "Last four weeks": "letzte vier Wochen",
  "Last week": "letzte Woche",
  "Current month": "aktueller Monat",
  "Last month": "letzter Monat",
  "Last quarter": "letztes Quartal",
  "Last half year": "letztes Halbjahr",
  "Current year": "aktuelles Jahr",
  "Last year": "letztes Jahr",
  "Last 12 months": "letzte 12 Monate",
  "Lifetime": "gesamter Zeitraum",
  "Custom period": "benutzerdefiniert",
  "Selected period": "ausgewählter Zeitraum",
} as const;

export const sharedPeriodSelectorEn = {
  "Last 14 days": "last 14 days",
  "Last 30 days": "last 30 days",
  "Last 90 days": "last 90 days",
  "Last four weeks": "last four weeks",
  "Last week": "last week",
  "Current month": "current month",
  "Last month": "last month",
  "Last quarter": "last quarter",
  "Last half year": "last half year",
  "Current year": "current year",
  "Last year": "last year",
  "Last 12 months": "last 12 months",
  "Lifetime": "lifetime",
  "Custom period": "custom period",
  "Selected period": "selected period",
} as const;

export const sharedPeriodSelectorRu = {
  "Last 14 days": "последние 14 дней",
  "Last 30 days": "последние 30 дней",
  "Last 90 days": "последние 90 дней",
  "Last four weeks": "последние четыре недели",
  "Last week": "последняя неделя",
  "Current month": "текущий месяц",
  "Last month": "прошлый месяц",
  "Last quarter": "последний квартал",
  "Last half year": "последнее полугодие",
  "Current year": "текущий год",
  "Last year": "прошлый год",
  "Last 12 months": "последние 12 месяцев",
  "Lifetime": "весь период",
  "Custom period": "произвольный период",
  "Selected period": "выбранный период",
} as const;

export const sharedPeriodSelectorUk = {
  "Last 14 days": "останні 14 днів",
  "Last 30 days": "останні 30 днів",
  "Last 90 days": "останні 90 днів",
  "Last four weeks": "останні чотири тижні",
  "Last week": "минулий тиждень",
  "Current month": "поточний місяць",
  "Last month": "минулий місяць",
  "Last quarter": "минулий квартал",
  "Last half year": "минулі пів року",
  "Current year": "поточний рік",
  "Last year": "минулий рік",
  "Last 12 months": "останні 12 місяців",
  "Lifetime": "весь період",
  "Custom period": "власний період",
  "Selected period": "вибраний період",
} as const;

export const sharedPeriodSelectorIt = {
  "Last 14 days": "ultimi 14 giorni",
  "Last 30 days": "ultimi 30 giorni",
  "Last 90 days": "ultimi 90 giorni",
  "Last four weeks": "ultime quattro settimane",
  "Last week": "ultima settimana",
  "Current month": "mese corrente",
  "Last month": "mese scorso",
  "Last quarter": "ultimo trimestre",
  "Last half year": "ultimo semestre",
  "Current year": "anno corrente",
  "Last year": "anno scorso",
  "Last 12 months": "ultimi 12 mesi",
  "Lifetime": "intero periodo",
  "Custom period": "periodo personalizzato",
  "Selected period": "periodo selezionato",
} as const;

export const sharedPeriodSelectorTranslations = {
  de: sharedPeriodSelectorDe,
  en: sharedPeriodSelectorEn,
  ru: sharedPeriodSelectorRu,
  uk: sharedPeriodSelectorUk,
  it: sharedPeriodSelectorIt,
} as const;

export type SharedPeriodSelectorLang = keyof typeof sharedPeriodSelectorTranslations;
export type SharedPeriodSelectorKey = keyof typeof sharedPeriodSelectorDe;
